import { jsx as i, jsxs as A, Fragment as w } from "react/jsx-runtime";
import { Button as K, Icon as Q } from "@blueprintjs/core";
import { IconNames as B } from "@blueprintjs/icons";
import { conditionalString as U, sortAsc as D } from "@strata/helper-functions";
import { ActionButtonText as G } from "@strata/react-buttons";
import { CollapsibleSidebarAndMainContent as X } from "@strata/react-collapsible-sidebar-and-main-content";
import { DetailLabel as Y } from "@strata/react-label-value-pairs";
import { Tag as Z } from "@strata/react-tags";
import { useState as C, useMemo as S, useEffect as T, useCallback as r } from "react";
import { CheckboxList as V } from "@strata/react-checkbox-list";
import { CollapsibleSection as z } from "@strata/react-collapsible-section";
import { RadioButtonGroup as P } from "@strata/react-radio-button-group";
import "./main.scss";
import { TextInput as H } from "@strata/react-inputs";
import v from "classnames";
const y = (o) => {
  o((n) => !n);
}, a = ({
  title: o,
  useRadioButtons: n = !1,
  values: s = [],
  activeFilters: c = [],
  onChange: _
}) => {
  var m;
  const [x, l] = C(!1), d = (m = s == null ? void 0 : s.slice(0, x ? s == null ? void 0 : s.length : 5)) == null ? void 0 : m.map((t) => ({
    ...t,
    // Show count if present
    text: `${t.text}${U(t.count != null, ` (${t.count})`)}`
  }));
  return /* @__PURE__ */ i(
    z,
    {
      className: "sds_filter-section padding__bottom--xx-small",
      title: o,
      chevronSize: z.ChevronSize.SMALL,
      fill: !0,
      content: /* @__PURE__ */ A("div", { className: "sds_filter-section__values", children: [
        n ? /* @__PURE__ */ i(
          P,
          {
            name: o,
            options: d,
            selectedValue: c == null ? void 0 : c[0],
            onChange: (t) => _([t])
          }
        ) : /* @__PURE__ */ i(
          V,
          {
            name: o,
            options: d,
            values: c,
            onChange: _
          }
        ),
        (s == null ? void 0 : s.length) > 5 && /* @__PURE__ */ i(
          G,
          {
            className: "margin__top--small",
            label: `See ${x ? "Less" : "More"}`,
            onClick: () => y(l)
          }
        )
      ] })
    }
  );
}, F = ({
  value: o = void 0,
  onSearch: n = void 0,
  className: s = void 0
}) => /* @__PURE__ */ i("div", { className: v("sds_search", s), children: /* @__PURE__ */ i(
  H,
  {
    id: "search",
    name: "search",
    leftIcon: B.SEARCH,
    placeholderText: "Search",
    value: o,
    verticalSpacingSmall: !0,
    onChange: (c) => n == null ? void 0 : n(c.target.value),
    rightElement: o ? /* @__PURE__ */ i(
      K,
      {
        className: "sds_search__clear-button",
        icon: B.CROSS,
        minimal: !0,
        onClick: () => n == null ? void 0 : n("")
      }
    ) : void 0
  }
) }), nn = (o, n) => {
  const s = {};
  return o == null || o.forEach((c) => {
    const {
      key: _,
      title: x,
      showCounts: l,
      useRadioButtons: d,
      valueDisplayTextMap: m,
      customValues: t,
      defaultValue: e
    } = c;
    if (s[_] = {
      title: x,
      values: [],
      defaultValue: e,
      useRadioButtons: d
    }, t)
      s[_].values = t.map((p) => ({
        value: p.value,
        text: p.text ?? p.value,
        // Run handler for every row to determine count if showCounts is true
        count: l ? (n == null ? void 0 : n.reduce(
          (f, R) => {
            var h;
            return f + ((h = p == null ? void 0 : p.handler) != null && h.call(p, R[_], R) ? 1 : 0);
          },
          0
        )) ?? 0 : void 0
      }));
    else {
      const p = {};
      n == null || n.forEach((f) => {
        const R = f[_];
        R != null && (p[R] = (p[R] ?? 0) + 1);
      }), s[_].values = Object.keys(p).map((f) => ({
        value: f,
        text: (m == null ? void 0 : m[f]) ?? f,
        count: l ? p[f] : void 0
      })).sort((f, R) => D(f.text.toString(), R.text.toString()));
    }
  }), s;
}, M = (o) => Object.fromEntries(
  (o ?? []).filter((n) => n.defaultValue).map((n) => [n.key, n.defaultValue])
), g = () => /* @__PURE__ */ i(Q, { icon: B.FILTER, size: 16 }), Rn = ({
  title: o,
  secondaryTitle: n,
  viewsPaneContent: s = void 0,
  headerContent: c,
  mainContent: _,
  data: x = void 0,
  filterCategories: l = void 0,
  activeFilters: d = void 0,
  onFilter: m = void 0,
  enableSearch: t = !1,
  searchText: e = void 0,
  onSearch: p,
  paneRenderWidth: f = void 0,
  onPaneResize: R = void 0
}) => {
  const h = S(
    () => nn(l, x),
    [x, l]
  );
  T(() => {
    d || m == null || m(M(l));
  }, [d, l, m]);
  const W = (b, N, k) => {
    var j;
    let u = (j = d == null ? void 0 : d[b]) == null ? void 0 : j.filter((L) => L !== N);
    (!u || (u == null ? void 0 : u.length) === 0) && (u = k ?? []), m == null || m({
      ...d,
      [b]: u
    });
  }, q = (b, N) => {
    m == null || m({
      ...d,
      [b]: N
    });
  }, E = Object.entries(d ?? {}).map(
    ([b, N]) => (N ?? []).map((k) => {
      var j, L;
      const u = h == null ? void 0 : h[b];
      return {
        category: b,
        value: k,
        text: (L = (j = u == null ? void 0 : u.values) == null ? void 0 : j.find((J) => J.value === k)) == null ? void 0 : L.text,
        defaultValue: u == null ? void 0 : u.defaultValue
      };
    })
  ).flat().sort((b, N) => D(b.text, N.text)), O = (E == null ? void 0 : E.length) > 0 || e, I = r(
    () => /* @__PURE__ */ A(w, { children: [
      /* @__PURE__ */ i("span", { className: "sds_filter-sidebar__header-text", children: "Filters" }),
      O && /* @__PURE__ */ i(
        G,
        {
          label: "Clear Filters",
          onClick: () => {
            m == null || m(M(l)), p == null || p("");
          }
        }
      )
    ] }),
    [l, O, m, p]
  ), $ = t || (l ?? []).length > 0;
  return /* @__PURE__ */ i(
    X,
    {
      title: o,
      secondaryTitle: n,
      headerContent: c,
      sidebarRenderWidth: f,
      onSidebarResize: R,
      sidebarHeaderContent: {
        minimized: s ? null : /* @__PURE__ */ i(g, {}),
        expanded: s ? /* @__PURE__ */ i("span", { className: "sds_filter-sidebar__header-text", children: "Views" }) : /* @__PURE__ */ i(I, {})
      },
      sidebarContent: /* @__PURE__ */ A("div", { className: "sds_filter-sidebar", children: [
        s && /* @__PURE__ */ A(w, { children: [
          /* @__PURE__ */ i("div", { className: "sds_filter-sidebar__views-pane", children: /* @__PURE__ */ i("div", { className: "sds_filter-sidebar__views-pane--content", children: s }) }),
          $ && /* @__PURE__ */ A("div", { className: "sds_collapsible-sidebar-and-main-content__sidebar-header", children: [
            /* @__PURE__ */ i(g, {}),
            /* @__PURE__ */ i(I, {})
          ] })
        ] }),
        (!s || $) && /* @__PURE__ */ A("div", { className: "sds_filter-section padding__top--xx-small", children: [
          O && /* @__PURE__ */ A(
            "div",
            {
              className: "margin__around--medium",
              style: t ? { marginBottom: 0 } : void 0,
              children: [
                /* @__PURE__ */ i(Y, { label: "Filtering On:" }),
                E.map(
                  ({ category: b, value: N, text: k, defaultValue: u }) => /* @__PURE__ */ i(
                    Z,
                    {
                      className: "margin__bottom--small margin__right--small",
                      label: k,
                      onRemove: u != null && u.includes(N) ? void 0 : () => W(
                        b,
                        N,
                        u
                      )
                    },
                    `${b}${N}`
                  )
                )
              ]
            }
          ),
          t && /* @__PURE__ */ i(
            F,
            {
              className: "margin__around--medium",
              value: e,
              onSearch: p
            }
          )
        ] }),
        Object.keys(h).map(
          (b) => {
            var N;
            return (((N = h[b].values) == null ? void 0 : N.length) ?? 0) > 0 && /* @__PURE__ */ i(
              a,
              {
                title: h[b].title,
                useRadioButtons: h[b].useRadioButtons,
                values: h[b].values,
                activeFilters: d == null ? void 0 : d[b],
                onChange: (k) => q(b, k)
              },
              b
            );
          }
        )
      ] }),
      mainContent: _
    }
  );
}, kn = (o, n, s) => o == null ? void 0 : o.filter(
  (c) => Object.keys(n ?? {}).filter((_) => {
    var x;
    return (((x = n == null ? void 0 : n[_]) == null ? void 0 : x.length) ?? 0) > 0;
  }).every(
    (_) => {
      var x;
      return (
        // Evaluate value against each active filter for category. If no match found for category, filter out item
        (x = n == null ? void 0 : n[_]) == null ? void 0 : x.some(
          (l) => {
            var d, m, t, e, p;
            return ((e = (t = (m = (d = s == null ? void 0 : s.find((f) => f.key === _)) == null ? void 0 : d.customValues) == null ? void 0 : m.find((f) => f.value === l)) == null ? void 0 : t.handler) == null ? void 0 : e.call(t, c[_], c)) ?? l === ((p = c[_]) == null ? void 0 : p.toString());
          }
        )
      );
    }
  )
), en = (o, n, s) => n ? o == null ? void 0 : o.filter(
  (c) => Object.keys(c).some(
    (_) => {
      var x, l, d;
      return (d = (l = ((x = s == null ? void 0 : s[_]) == null ? void 0 : x.call(s, c[_])) ?? c[_]) == null ? void 0 : l.toString) == null ? void 0 : d.call(l).toLowerCase().includes(n == null ? void 0 : n.toLowerCase());
    }
  )
) : o;
export {
  Rn as FilterPane,
  F as Search,
  kn as filterData,
  en as filterDataFromSearch
};
//# sourceMappingURL=index.js.map
